import { Map } from 'immutable';
import get from 'lodash/get';

import {
  ELEMENTS__CREATE,
  ELEMENTS__FETCH,
  ELEMENTS__UPDATE,
  ELEMENT_TYPE__IMAGE_INPUT,
  ELEMENT_TYPE__IMAGE_MULTI_SELECT_INPUT,
  ELEMENT_TYPE__IMAGE,
  ELEMENT_TYPE__RANKING_IMAGE_INPUT,
  PAGES__COPY,
  PAGES__CREATE,
  SURVEY_EDITOR__RESET,
  SURVEYS__FETCH_ACTIVE,
  UPLOADER__DELETE,
  UPLOADER__UPLOAD,
  UPLOADER__CREATE_PLACEHOLDERS,
  USER__LOG_OFF,
} from '../constants';
// import * as utils from '../../util';
import { getErrorType } from '../api-client/selectors.api-client';

import { parsePageTree } from '../pages/reducer.pages';

const UPLOAD_ID = 'uploadId';
const defaultState = new Map();

const getCaption = (captions, captionId) =>
  get(
    captions.find((caption) => caption.id === captionId),
    'caption',
  );

const removePlaceholders = (state) => state.filter((image) => !state.has(image.get(UPLOAD_ID)));

const mergeImage = (state, elementId, image, captions, sortOrder = 0) => {
  if (!image) return state;
  const nextState = state.merge({
    [image.id]: {
      ...image,
      caption: captions && getCaption(captions, image.id),
      elementId,
      sortOrder,
    },
  });
  return nextState;
};

const mergeImages = (state, { id: elementId, properties: { captions, urls } }) =>
  urls.reduce(
    (nextState, image, sortOrder) => mergeImage(nextState, elementId, image, captions, sortOrder),
    state,
  );

const mergeElements = (state, elements) =>
  elements.reduce((nextState, element) => {
    switch (element.type) {
      case ELEMENT_TYPE__IMAGE_INPUT:
      case ELEMENT_TYPE__IMAGE_MULTI_SELECT_INPUT:
      case ELEMENT_TYPE__RANKING_IMAGE_INPUT:
        return mergeImages(nextState, element);
      case ELEMENT_TYPE__IMAGE:
        return mergeImage(nextState, element.id, element.properties.urls);
      default:
        return nextState;
    }
  }, state);

const mergePagesTree = (state, data) =>
  removePlaceholders(
    data.reduce((nextState, page) => mergeElements(nextState, parsePageTree(page).elements), state),
  );

const mergePlaceholders = (state, { files, elementId }) =>
  files.reduce((prevState, { name: id, preview, type }) => {
    const [fileType] = type.split('/');
    return fileType === 'image'
      ? prevState.merge({
          [id]: {
            id,
            elementId,
            sortOrder: prevState.size,
            isLoading: true,
            desktop: { url: preview },
            large: { url: preview },
            original: { url: preview },
            small: { url: preview },
          },
        })
      : prevState;
  }, state);
const deletePlaceholder = (state, { name: id }) => state.delete(id);
const patchPlaceholder = (state, action) =>
  state
    .filter((file) => !(action.replaceOld && file.get('elementId') === action.elementId))
    .setIn([action.file.name, UPLOAD_ID], action.data.id);

export default function (state = defaultState, action) {
  switch (action.type) {
    case ELEMENTS__CREATE:
    case ELEMENTS__FETCH:
    case ELEMENTS__UPDATE:
    case PAGES__COPY:
    case PAGES__CREATE:
      return mergePagesTree(state, action.data);
    case UPLOADER__DELETE:
      return state.delete(action.uploadId);

    case UPLOADER__CREATE_PLACEHOLDERS:
      return mergePlaceholders(state, action);

    case UPLOADER__UPLOAD:
      return patchPlaceholder(state, action);

    case getErrorType(UPLOADER__UPLOAD):
      return deletePlaceholder(state, action.file);

    case SURVEYS__FETCH_ACTIVE:
      return mergePagesTree(state, action.data.elements);
    case SURVEY_EDITOR__RESET:
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
